import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {environment} from '../../environments/environment';
import {HomepageData, MenuItem, Page, PageData} from './data.model';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  public homepageData = new BehaviorSubject<HomepageData>(undefined);
  public menu = new BehaviorSubject<Array<MenuItem>>([]);
  public pages = new BehaviorSubject<Array<Page>>([]);

  constructor(private http: HttpClient) {
  }

  public getPageData(): void {
    this.http.get(environment.cmsUrl + environment.routes.getInitialData).subscribe((data: PageData) => {
      if (data.status) {
        if (!environment.production) {
          console.log({'Page data': data});
        }

        this.homepageData.next(data.homepage);
        this.menu.next(data.menu);
        this.pages.next(data.pages);
      } else {
        console.log(data.message);
      }
    });
  }
}
